module.exports = __webpack_public_path__ + "img/66000.95ef3665.jpg";